import {useHistory} from 'react-router-dom'
import '../masters/basic.css'
import { RequestWebsiteTable } from './RequestWebsiteTable'
export function RequestWebsite(props: any) {
  const history: any = useHistory()
  const pageType = history.location.state?.type
  return (
    <div className='Outer d-flex'>
      <div className='TableDiv'> 
        <RequestWebsiteTable type={pageType}></RequestWebsiteTable>
      </div>
    </div>
  )
}